import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { PageCimaExemptionCalculator } from 'components/pages/PageCimaExemptionCalculator';

// selectors
import { isAuthSelector } from 'modules/user/selectors';

const mapActionCreators = (dispatch: Dispatch) => ({});

const mapStateToProps = (state: State.Root) => ({
  isAuth: isAuthSelector(state),
});

export const CimaExemptionCalculatorContainer = connect(
  mapStateToProps,
  mapActionCreators
)(PageCimaExemptionCalculator);
